module.exports = __webpack_public_path__ + "static/media/city_3.9c8af41d.jpg";